import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=53dd7df5&scoped=true&"
import script from "./Signup.vue?vue&type=script&lang=js&"
export * from "./Signup.vue?vue&type=script&lang=js&"
import style0 from "./Signup.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Signup.vue?vue&type=style&index=1&id=53dd7df5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd7df5",
  null
  
)

export default component.exports